import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

import styles from './LoadingSkeleton.module.scss'

/**
 * LoadingSkeleton provides customizable loading skeletons for different UI components
 */
export const LoadingSkeleton = ({ type = 'table', itemCount = 5 }) => {
  switch (type) {
    case 'metrics':
      return (
        <Box className={styles.metricsContainer}>
          <Box className={styles.metricsRow}>
            <Skeleton height={100} width='32%' />
            <Skeleton height={100} width='32%' />
            <Skeleton height={100} width='32%' />
          </Box>
          <Skeleton height={250} width='100%' />
          <Skeleton height={250} width='100%' className={styles.chartSkeleton} />
        </Box>
      )

    case 'header':
      return (
        <Box className={styles.headerContainer}>
          <Skeleton height={32} width='40%' className={styles.title} />
          <Skeleton height={20} width='60%' className={styles.subtitle} />
          <Skeleton height={28} width='20%' className={styles.action} />
        </Box>
      )

    case 'dateRange':
      return (
        <Box className={styles.dateRangeContainer}>
          <Skeleton height={40} width='30%' />
          <Skeleton height={40} width='30%' />
          <Skeleton height={40} width='30%' />
        </Box>
      )

    case 'table':
    default:
      return (
        <Box className={styles.tableContainer}>
          <Skeleton height={48} className={styles.header} />
          <Skeleton count={2} height={24} className={styles.description} />
          <Skeleton height={48} className={styles.tableHeader} />
          {Array(itemCount).fill().map((_, i) => (
            <Skeleton key={i} height={80} className={styles.tableRow} />
          ))}
          <Skeleton height={48} className={styles.pagination} />
        </Box>
      )
  }
}

LoadingSkeleton.propTypes = {
  type: PropTypes.oneOf(['table', 'metrics', 'header', 'dateRange']),
  height: PropTypes.number,
  itemCount: PropTypes.number
}

export default LoadingSkeleton
